import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import GridFilterPanel from '../../commons/filters/GridFilterPanel.jsx';
import * as Utils from '../../commons/utils/Utils';
import { aOpciones } from '../moviles/movilesFilterOptions.js';
import { EQUIPAMIENTO_FILTROS_STORAGE_KEY, buildEquipamientoFilterFields } from './equipamientoFilterFields.js';

const EquipamientoGridFiltros = (props) => {
	const intl = useIntl();
	const [options, setOptions] = useState({ tipo: [] });
	const [optionsLoading, setOptionsLoading] = useState(true);

	useEffect(() => {
		setOptionsLoading(true);
		Utils.getData('/tipoequipamiento')
			.then((tipos) => setOptions({ tipo: aOpciones(tipos, 'nombre') }))
			.catch(() => setOptions({ tipo: [] }))
			.finally(() => setOptionsLoading(false));
	}, []);

	return (
		<GridFilterPanel
			open={props.open}
			fields={buildEquipamientoFilterFields(intl)}
			options={options}
			defaults={{}}
			storageKey={EQUIPAMIENTO_FILTROS_STORAGE_KEY}
			loading={props.loading || optionsLoading}
			applyOnMount={true}
			resetSignal={props.resetSignal}
			onResetSignalHandled={props.onResetSignalHandled}
			onApply={props.onApply}
		/>
	);
};

export default EquipamientoGridFiltros;
